<template lang="html">
  <section class="subview-container column client">
		<notifications classes="master-notifications" position="top left" group="default" />
		<div class="contentrow alone certified row" v-if="client.certified === 'NOT CERTIFIED'">
			<div class="content row">
				<span class="icon-alert"></span>
				<div class="info">
					<div class="label">
						Identité non vérifiée
					</div>
					<div class="value">
						La vérification d'identité est impérative pour la signature des documents de mission
					</div>
				</div>
			</div>
			<div class="btn btn-red" @click="modals.certified = true">
				<span class="icon-button-contact"></span>
				Lancer la vérification
			</div>
		</div>
		<div class="contentrow alone certified row" v-if="client.certified === 'PENDING'">
			<div class="content row">
				<span class="icon-alert orange"></span>
				<div class="info">
					<div class="label">
						Vérification d'identité en cours
					</div>
					<div class="value">
						La vérification d'identité est impérative pour la signature des documents de mission
					</div>
				</div>
			</div>
		</div>
		<div class="contentrow row">
			<div class="half head-profil row">
				<router-link :to="{ name: 'Contacts' }" class="btn btn-red small">
					<span class="icon-arrow-back"></span>
				</router-link>
				<div class="ctn-profile-picture">
					<img v-img-detect :src="profilePicture" alt="">
				</div>
				<div class="ctn-info-name column">
					<div class="name bold row">
						{{ client.firstname }} {{ client.lastname }} <img v-if="client.certified === 'CERTIFIED'" :src="good" alt="">
					</div>
					<div class="subscribed">
					{{ (client.type === 'client_subscriber') ? 'Client' : 'Prospect' }}
					</div>
					<div class="btn btn-red" v-if="!client.lcbft_completed" @click="modals.lcbcft = true">
						<span class="icon-button-warning"></span>
						Remplir le formulaire LCB-FT
					</div>
				</div>
				<div class="ctn-cta column">
					<router-link class="btn btn-red" :to="{ name: 'ChatClient' }">
						Conversations
					</router-link>
					<div class="btn btn-red" @click="modals.takeAppointment=true">
						<span class="icon-button-rdv"></span>
						Planifier un RDV
					</div>
				</div>
			</div>
			<div class="half notes">
				<div class="heading row">
					<div class="title row">
						<span class="icon-fiche-client-note"></span>
						Ajout de notes
					</div>
					<div class="add">
						<div class="btn btn-gold" @click="launchNoteModal(true)">
							Nouvelle note
						</div>
					</div>
				</div>
				<div class="boding">
					<div class="no-notes empty" v-if="!client.notes || client.notes.length === 0">
						Prenez quelques note sur votre client en cliquant sur « Nouvelle note »
					</div>
					<div class="notes row" v-else>
						<div class="note row" v-for="note in client.notes" @click="launchNoteModal(false, note)">
							<div class="title">
								{{ note.title }}
							</div>
							<div class="date">
								{{ note.created_at.split(' ')[0] }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="contentrow alone row">
		<template v-if="client.investment_stats && !Array.isArray(client.investment_stats)">
			<div class="info-value row">
				<div class="label">
					Montant investi
				</div>
				<div class="value">
					{{client.investment_stats.amount_invested|format_currency('€')}}
				</div>
			</div>
			<div class="info-value row">
				<div class="label">
					Avoirs
				</div>
				<div class="value">
					{{client.investment_stats.my_assets|format_currency('€')}}
				</div>
			</div>
			<div class="info-value row" v-if="!client.investment_stats.hide_performance">
				<div class="label">
					Performance globale
				</div>
				<div class="value" v-if="client.investment_stats.global_performance">
					{{client.investment_stats.global_performance|format_performance}}%
				</div>
					<div class="icon">
						<img v-if="client.investment_stats.global_performance >= 0" :src="highIcon" alt="">
						<img v-else :src="downIcon" alt="">
				</div>
			</div>
      <div class="row">
        <div class="buttons">
          <router-link :to="{name: 'InvestmentsManual', params: {clientId: client.id}}" class="btn btn-gold">
            <span class="icon-file-edit"></span> Agrégation manuelle
          </router-link>
          <router-link :to="{name: 'InvestmentsClient', params: {clientId: client.id}}" class="btn btn-red">
            <span class="icon-button-situation"></span> Situation détaillée
          </router-link>
        </div>
      </div>
		</template>
		<template v-else>
			<div class="no-investments column">
        <p>
          Votre client n'a pas encore investit
        </p>
        <div>
          <router-link :to="{name: 'InvestmentsManual', params: {clientId: client.id}}" class="btn btn-gold">
            <span class="icon-file-edit"></span> Agrégation manuelle
          </router-link>
        </div>
			</div>
    </template>
		</div>
		<div class="contentrow row">
			<div class="half story">
				<div class="heading row">
					<div class="title row">
						<span class="icon-fiche-client-history"></span>
						Historique
					</div>
					<div class="add row">
						<router-link v-if="client.lcbft_completed" :to="{ name: 'MyTransactionsAdd' }" class="btn btn-gold">
							Nouvelle Opération
						</router-link>
						<router-link :to="{ name: 'TransactionsTable' }" class="btn btn-gold">
							Voir tout
						</router-link>
					</div>
				</div>
				<div class="boding">
					<div class="no-story empty" v-if="client.missions.length === 0">
						Aucune opérations enregistrée.
						<div v-if="!client.lcbft_completed">
							Remplissez le formulaire LCBC-FT de votre client<br/>
							avant de créer une nouvelle opérations
						</div>
					</div>
					<div class="stories" v-else>
						<div class="stories-header row">
							<div class="stories-column">Nom</div>
							<div class="stories-column">Lettre de mission</div>
							<div class="stories-column">Compte rendu de mission</div>
							<div class="stories-column"></div>
 						</div>
						<div class="stories-body column">
							<div class="stories-row row" v-for="(mission, key) in client.missions" v-bind:key="key">
								<div class="stories-column">{{ mission.title }}</div>
								<div class="stories-column" v-html="getMissionDoc(mission, 'Lettre de mission')"></div>
								<div class="stories-column" v-html="getMissionDoc(mission, 'Rapport de mission')"></div>
								<router-link :to="{ name: 'MyTransactionsEdit', params: { id: mission.id } }" class="stories-column"><span class="icon-eye"></span></router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="half docs column">
				<div class="heading row">
					<div class="title row">
						<span class="icon-fiche-client-docs"></span>
						Documents récents
					</div>
					<div class="add">
						<router-link :to="{ name: 'Documents' }" class="btn btn-gold">
							Voir tous les documents
						</router-link>
					</div>
				</div>
				<div class="boding column">
					<div class="no-docs empty" v-if="lastDocuments.length === 0">
						<br/>Aucun documents disponibles<br/><br/>
					</div>
					<div class="docs row" v-else>
						<tile-doc :doc="doc" v-for="(doc, key) in lastDocuments" v-bind:key="key" />
					</div>
				</div>
			</div>
		</div>
		<div class="contentrow row">
			<div class="inner-row row">
				<div class="half infos">
					<div class="heading row">
						<div class="title row">
							<span class="icon-fiche-client-info"></span>
							Informations
						</div>
						<div class="add">
							<div class="btn btn-gold" @click="modals.editClient=true">
								Edit
							</div>
						</div>
					</div>
					<div class="boding column">
						<div class="row info">
							<div class="label"> ID client </div>
							<div class="value"> #{{ client.id }}</div>
						</div>
						<div class="row info">
							<div class="label"> Nom complet </div>
							<div class="value"> {{ client.firstname }} {{ client.lastname }}</div>
						</div>
						<div class="row info">
							<div class="label">Date de naissance</div>
							<div class="value">{{ client.birthdate | moment('DD MMMM YYYY')}}</div>
						</div>
						<div class="row info">
							<div class="label">Téléphone</div>
							<div class="value">{{ client.phone || '-' }}</div>
						</div>
						<div class="row info">
							<div class="label">Adresse mail</div>
							<div class="value">{{ client.email || '-' }}</div>
						</div>
						<div class="row info">
							<div class="label">Adresse postal</div>
							<div class="value" v-if="client.address">{{ client.address.line || '-' }}</div>
						</div>
						<div class="row info">
							<div class="label">Ville</div>
							<div class="value" v-if="client.address">{{ client.address.city || '-' }}</div>
						</div>
						<div class="row info">
							<div class="label">Code postal</div>
							<div class="value" v-if="client.address">{{ client.address.zip || '-' }}</div>
						</div>
            <div class="column info tags">
              <div class="label">Centres d'intérêts</div>
              <div class="value row ctn-tags">
                <div class="tag" v-for="(tag, key) in client.center_of_interest" v-bind:key="key">
                  {{ tag.wordpress_tag_name }}
                </div>
              </div>
            </div>
					</div>
				</div>
				<div class="half infos patrimoine column">
					<div class="heading row">
						<div class="title row">
							<span class="icon-fiche-client-paysage"></span>
							Paysage Patrimonial
						</div>
						<div class="add row">
							<!-- <div class="btn btn-gold">
								Edit
							</div> -->
							<router-link :to="{name: 'PatrimonialLandscape', params: {clientId: client.id}}" class="btn btn-gold">
								Voir
							</router-link>
						</div>
					</div>
					<div class="boding column">
						<div class="no-patrimoine empty column" v-if="!estate.birthdate">
							Votre client doit remplir <br/>
							son Paysage Patrimonial pour <br/>
						 	pouvoir commencer à investir.
							<div class="btn btn-red" @click="sendRelance">
								<span class="icon-button-relance"></span>
								Envoyer une relance
							</div>
						</div>
						<div class="patrimoines take-place" v-else>
							<div class="btn btn-red" @click="modals.patrimonialConsistency = true">
								<span class="icon-button-warning"></span>
									Vérification de la complétude et de la cohérence des informations fournies par le client
								</div>
							<div class="row info">
								<div class="label">Age</div>
								<div class="value">{{ computedAge(estate.birthdate) + ' ans' || '-' }}</div>
							</div>
							<div class="row info">
								<div class="label">Métier</div>
								<div class="value">{{ estate.job || '-' }}</div>
							</div>
							<div class="row info">
								<div class="label">CSP</div>
								<div class="value">{{ estate.csp || '-' }}</div>
							</div>
							<div class="row info">
								<div class="label">Enfants</div>
								<div class="value">{{ estate.childs.length }} à charge</div>
							</div>
							<div class="info row">
								<div class="label">Revenu annuel</div>
								<div class="value">{{ estate.total.incomes || '-' }}</div>
							</div>
							<div class="info row">
								<div class="label">Immobilier</div>
								<div class="value">{{ estate.total.immobilier || '-' }}</div>
							</div>
							<div class="info row">
								<div class="label">Epargne</div>
								<div class="value">{{ estate.total.savings || '-' }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="inner-row row">
				<div class="half column appointment">
					<div class="heading row">
						<div class="title row">
							<span class="icon-fiche-client-calandar"></span>
							Rendez-vous
						</div>
						<div class="add" v-if="client.rdvs.length > 0"></div>
					</div>
					<div class="boding column row">
						<div class="next row">
							Prochain rendez-vous
							<div class="bar"></div>
						</div>
						<div class="no-appointment empty row" v-if="client.rdvs.length === 0">
							Planifiez votre première rencontre en cliquant sur "Planifier un RDV"
						</div>
						<div class="appointments column" v-else>
							<div class="ctn-appointment" v-for="rdv in client.rdvs">
								<div class="appointment-head row">
									<div class="pastille" :class="classResolver(rdv.type)"></div>
									<div class="type">{{ rdv.type }}</div>
								</div>
								<div class="appointment-body row">
									<div class="date" v-html="dateResolver(rdv)"></div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="half column flex-start">
					<div class="heading row">
						<div class="title row">
							<span class="icon-fiche-client-calandar"></span>
							Où sont ses placements ?
						</div>
						<div class="add">
							<div class="btn btn-gold" @click="saveSelectedCountries">
								Enregistrer
							</div>
						</div>
					</div>
					<div class="boding column row countries-form">
						<div class="search-box">
							<input
								type="text"
								v-model="countrySearch"
								placeholder="Rechercher un pays..."
								class="country-search-input"
							/>
						</div>
						<div class="countries-list">
							<div
								v-for="country in filteredCountries"
								:key="country.ISO2"
								class="country-item"
							>
								<input
									type="checkbox"
									:id="'country-' + country.ISO2"
									:value="country.ISO2"
									v-model="selectedCountries"
								/>
								<label :for="'country-' + country.fr">
									{{ country.fr }}
								</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="contentrow row">
			<div class="half infos company-info-section">
				<div class="heading row">
					<div class="title row">
						<span class="icon-fiche-client-info"></span>
						Informations Société
					</div>
					<div class="add">
						<div class="btn btn-gold" @click="modals.companyInfo = true">
							Voir / Éditer
						</div>
					</div>
				</div>
				<div class="boding column">
					<div class="no-company-info empty column" v-if="!companyInfo || !companyInfo.company_name">
						Les informations de la société<br/>
						doivent être complétées pour<br/>
						les clients personnes morales.
						<div class="btn btn-red" @click="modals.companyInfo = true">
							<span class="icon-button-warning"></span>
							Compléter les informations
						</div>
					</div>
					<div class="company-infos take-place" v-else>
						<div class="row info">
							<div class="label">Société</div>
							<div class="value">{{ companyInfo.company_name || '-' }}</div>
						</div>
						<div class="row info">
							<div class="label">N° immatriculation</div>
							<div class="value">{{ companyInfo.registration_number || '-' }}</div>
						</div>
						<div class="row info">
							<div class="label">Régime fiscal</div>
							<div class="value">{{ companyInfo.tax_regime || '-' }}</div>
						</div>
						<div class="row info">
							<div class="label">Activité(s)</div>
							<div class="value">{{ companyInfo.activities || '-' }}</div>
						</div>
						<div class="row info">
							<div class="label">Dirigeant(s)</div>
							<div class="value">{{ formatManagers(companyInfo.managers) || '-' }}</div>
						</div>
						<div class="row info">
							<div class="label">Bénéficiaire(s) effectif(s)</div>
							<div class="value">{{ formatManagers(companyInfo.beneficiaries) || '-' }}</div>
						</div>
						<div class="row info">
							<div class="label"> Documents transmis</div>
							<div class="value">{{ formatDocument(companyInfo.documents_confirmed) || '-' }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<base-modal :show="modals.newNote" :data="modals.dataNote" @close="modals.newNote = false" :content="modalNewNote" />
		<base-modal :show="modals.editClient" :data="client" @close="modals.editClient = false" :content="modalEditClient" />
		<base-modal :show="modals.lcbcft" @close="modals.lcbcft = false" :content="modalLCBCFT" />
		<base-modal :show="modals.patrimonialConsistency" @close="modals.patrimonialConsistency = false" :content="modalPatrimonialConsistency" />
		<base-modal :show="modals.takeAppointment" @close="modals.takeAppointment = false" :data="client" :content="modalTakeAppointment" />
		<base-modal :show="modals.certified" @close="handleCloseCertified" :data="client" :content="modalCertified" />
		<base-modal :show="modals.companyInfo" :data="client" @close="handleCloseCompanyInfo" :content="modalCompanyInformation" />
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalNewNote from '@/components/Modal/NewNote'
import ModalEditClient from '@/components/Modal/EditContact'
import ModalLCBCFT from '@/components/Modal/LCBCFT.vue'
import ModalPatrimonialConsistency from '@/components/Modal/PatrimonialConsistency.vue'
import ModalTakeAppointment from '@/common/components/Modal/TakeAppointment'
import ModalCertified from '@/components/Modal/Certification'
import ModalCompanyInformation from '@/components/Modal/CompanyInformation'
import emma from '@/common/services/Emma'
import TileDoc from '@/common/components/tile-doc'
import Good from '@/common/assets/img/good.svg'
import Country from '@/common/components/MyPatrimonialLandscape/data/Country.js'
import HighIcon from '@/common/assets/img/high-icon.svg'
import DownIcon from '@/common/assets/img/down-icon.svg'

export default {
	name: 'Client',
	components: {
		TileDoc
	},
	data () {
		return {
			id: this.$route.params.clientId,
			modalNewNote: ModalNewNote,
			modalEditClient: ModalEditClient,
			modalLCBCFT: ModalLCBCFT,
			modalPatrimonialConsistency: ModalPatrimonialConsistency,
			modalTakeAppointment: ModalTakeAppointment,
			modalCertified: ModalCertified,
			modalCompanyInformation: ModalCompanyInformation,
			showEditClient: false,
			modals: {
				dataNote: {},
				newNote: false,
				editClient: false,
				lcbcft: false,
				takeAppointment: false,
				certified: false,
				patrimonialConsistency: false,
				companyInfo: false
			},
			lastDocuments: [],
			estateLoaded: false,
			good: Good,
			highIcon: HighIcon,
			downIcon: DownIcon,
			countrySearch: '',
			selectedCountries: [],
			countries: Country,
			companyInfo: null
		}
	},
	mounted () {
		this.init()
	},
	methods: {
		init () {
			this.$store.dispatch('getClient', this.id).then(() => {
				return this.$store.dispatch('getPatrimonial', this.id)
			}).then((result) => {
				return emma.get('api/clients/' + this.id + '/countries-placement')
			}).then((result) => {
				// Remplir selectedCountries avec les pays retournés par l'API
				// Le v-model des checkboxes cochera automatiquement les pays présents
				if (result.data && result.data.countries) {
					this.selectedCountries = result.data.countries
				}
			}).then(() => {
				return emma.get('api/clients/' + this.id + '/company-information')
			}).then((result) => {
				if (result.data && result.data.company) {
					this.companyInfo = result.data.company
				}
			}).then(() => {
				return emma.get('api/documents/operations/' + this.id)
			}).then((result) => {
				this.lastDocuments = result.data.documents.sort((docA, docB) => { return docA.id - docB.id }).slice(0, 4)
				this.estateLoaded = true
			})
			.catch((error) => {
				console.warn(error)
			})
		},
		launchNoteModal (isNew, note = null) {
			this.modals.dataNote = {
				clientId: this.id,
				isNew: isNew,
				note: {
					id: (!isNew) ? note.id : null,
					title: (!isNew) ? note.title : null,
					message: (!isNew) ? note.description : null
				}
			}
			this.modals.newNote = true
		},
		sendRelance () {
			emma.get('api/clients/sendmail/privateestate/' + this.id).then((result) => {
				console.log('Relance sent : ', result)
			})
		},
		classResolver (s) {
			if (s === 'Appel Téléphonique') {
				return 'red'
			} else if (s === 'Visio Call') {
				return 'brown'
			} else {
				return 'blue'
			}
		},
		dateResolver (rdv) {
			const begin = this.parseDate(rdv.start_date)
			const end = this.parseDate(rdv.end_date)
			const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche']
			const day = days[begin.getDay()]
			const months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
			const date = ('00' + begin.getDate()).slice(-2) + ' ' + months[begin.getMonth()] + ' ' + begin.getFullYear()
			return day + ' <span class="bold">' + date + '</span> de <span class="bold">' + begin.getHours() + 'h</span> à <span class="bold">' + end.getHours() + 'h</span>'
		},
		parseDate (date) {
			date = date.split(' ')
			let d = date[0].split('/')
			d = d.concat(date[1].split(':'))
			return new Date(d[2], d[1] - 1, d[0], d[3], d[4])
		},
		getMissionDoc (mission, type) {
			const doc = mission.documents.filter(doc => doc.sub_category === type)[0]
			if (doc) {
				if (doc.universign_status !== 'completed') {
					return `<span class="orange"><span class="icon-alert"></span> En attente</span>`
				} else {
					return `<span class="green"><img src="${this.good}"> Signé</span>`
				}
			} else {
				return `<span class="grey"><span class="icon-info"></span> A envoyer</span>`
			}
		},
		computedAge (date) {
			const d = this.$moment(date)
			const t = this.$moment()
			return t.diff(d, 'years')
		},
		handleCloseCertified () {
			this.modals.certified = false
			this.init()
		},
		handleCloseCompanyInfo () {
			this.modals.companyInfo = false
			this.init()
		},
		saveSelectedCountries () {
			emma.post('api/clients/' + this.id + '/countries-placement', {
				countries: this.selectedCountries
			}).then((result) => {
				// Notification de succès
				this.$notify({
					group: 'default',
					type: 'success',
					title: 'Succès',
					text: 'Pays enregistrés avec succès'
				})
			}).catch((error) => {
				// Notification d'erreur
				this.$notify({
					group: 'default',
					type: 'error',
					title: 'Erreur',
					text: 'Erreur lors de l\'enregistrement des pays'
				})
			})
		},
		formatManagers (managers) {
			if (!managers || !Array.isArray(managers) || managers.length === 0) {
				return '-'
			}
			return managers.filter(m => m && m.trim()).join(', ')
		},
		formatDocument (bool) {
			return bool = true ? "Oui" : "Non";
		}
	},
	filters: {
		format_currency (value, symbol) {
			return value ? (value.toLocaleString() + ' ' + symbol) : ''
		},
		format_performance (value) {
			if (!value) {
				return '0'
			}

			if (value === 0) {
				return value
			}

			return value > 0 ? ('+' + value.toLocaleString()) : value.toLocaleString()
		}
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		}),
		client () {
			return this.$store.getters.getClient(parseInt(this.id))
		},
		profilePicture () {
			return (this.client.media && this.client.media.file) ? process.env.ASSETS_ROOT + this.client.media.file : process.env.API_ROOT + 'assets/user.png'
		},
		filteredCountries () {
			// Créer une copie pour éviter de muter le tableau original
			let countriesList = [...this.countries]

			// Filtrer par recherche si nécessaire
			if (this.countrySearch) {
				const search = this.countrySearch.toLowerCase()
				countriesList = countriesList.filter(country => {
					return country.fr.toLowerCase().includes(search)
				})
			}

			// Trier pour mettre les pays sélectionnés en premier, puis par ordre alphabétique
			countriesList.sort((a, b) => {
				const aSelected = this.selectedCountries.includes(a.ISO2)
				const bSelected = this.selectedCountries.includes(b.ISO2)

				// Si l'un est sélectionné et l'autre non, le sélectionné vient en premier
				if (aSelected && !bSelected) return -1
				if (!aSelected && bSelected) return 1

				// Si les deux ont le même statut de sélection, trier par ordre alphabétique
				return a.fr.localeCompare(b.fr, 'fr')
			})

			return countriesList
		}
	}
}
</script>

<style lang="css" scoped>

.info-value .value + .icon {
    margin-left: 0.5rem;
}

.flex-start {
	justify-content: start;
}

/* Styles pour le formulaire des pays */
.countries-form {
	padding: 1rem;
	max-height: 400px;
	width: 100%;
}

.search-box {
	margin-bottom: 1rem;
	width: 100%;
}

.country-search-input {
	width: 100%;
	padding: 0.75rem 1rem;
	border: 1px solid #ddd;
	border-radius: 4px;
	font-size: 14px;
	transition: border-color 0.3s ease;
}

.country-search-input:focus {
	outline: none;
	border-color: #c4996e;
	box-shadow: 0 0 0 2px rgba(196, 153, 110, 0.1);
}

.country-search-input::placeholder {
	color: #999;
}

.countries-list {
	max-height: 300px;
	overflow-y: auto;
	padding-right: 0.5rem;
	width: 100%;
}

.countries-list::-webkit-scrollbar {
	width: 6px;
}

.countries-list::-webkit-scrollbar-track {
	background: #f1f1f1;
	border-radius: 3px;
}

.countries-list::-webkit-scrollbar-thumb {
	background: #c4996e;
	border-radius: 3px;
}

.countries-list::-webkit-scrollbar-thumb:hover {
	background: #b08858;
}

.country-item {
	display: flex;
	align-items: center;
	padding: 0.5rem;
	margin-bottom: 0.25rem;
	border-radius: 4px;
	transition: background-color 0.2s ease;
}

.country-item:hover {
	background-color: #f9f9f9;
}

.country-item input[type="checkbox"] {
	width: 18px;
	height: 18px;
	margin-right: 0.75rem;
	cursor: pointer;
	accent-color: #c4996e;
}

.country-item label {
	flex: 1;
	cursor: pointer;
	font-size: 14px;
	color: #333;
	user-select: none;
}

.country-item input[type="checkbox"]:checked + label {
	font-weight: 600;
	color: #c4996e;
}

/* Styles pour la section Informations Société */
.company-info-section .no-company-info {
	text-align: center;
	padding: 2rem 1rem;
	color: #666;
	font-size: 0.9rem;
	line-height: 1.8;
}

.company-info-section .no-company-info .btn {
	margin-top: 1rem;
}

.company-info-section .company-infos .info {
	padding: 0.75rem 0;
	border-bottom: 1px solid #f0f0f0;
}

.company-info-section .company-infos .info:last-child {
	border-bottom: none;
}

.company-info-section .company-infos .info .label {
	color: #666;
	font-size: 0.85rem;
}

.company-info-section .company-infos .info .value {
	font-family: "Lato Bold";
	color: #333;
}
</style>



// WEBPACK FOOTER //
// Client.vue?3785ef4e